var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccesos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3037_109074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3037_109074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C12.9 28 11.9583 27.6083 11.175 26.825C10.3917 26.0417 10 25.1 10 24C10 22.9 10.3917 21.9583 11.175 21.175C11.9583 20.3917 12.9 20 14 20C15.1 20 16.0417 20.3917 16.825 21.175C17.6083 21.9583 18 22.9 18 24C18 25.1 17.6083 26.0417 16.825 26.825C16.0417 27.6083 15.1 28 14 28ZM14 36C10.6667 36 7.83333 34.8333 5.5 32.5C3.16667 30.1667 2 27.3333 2 24C2 20.6667 3.16667 17.8333 5.5 15.5C7.83333 13.1667 10.6667 12 14 12C16.2333 12 18.2583 12.55 20.075 13.65C21.8917 14.75 23.3333 16.2 24.4 18H42L48 24L39 33L35 30L31 33L26.75 30H24.4C23.3333 31.8 21.8917 33.25 20.075 34.35C18.2583 35.45 16.2333 36 14 36ZM14 32C15.8667 32 17.5083 31.4333 18.925 30.3C20.3417 29.1667 21.2833 27.7333 21.75 26H28L30.9 28.05L35 25L38.55 27.75L42.3 24L40.3 22H21.75C21.2833 20.2667 20.3417 18.8333 18.925 17.7C17.5083 16.5667 15.8667 16 14 16C11.8 16 9.91667 16.7833 8.35 18.35C6.78333 19.9167 6 21.8 6 24C6 26.2 6.78333 28.0833 8.35 29.65C9.91667 31.2167 11.8 32 14 32Z",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesos);
export default __webpack_public_path__ + "static/media/accesos.e417e41648c58a27af958ad0bf54eb96.svg";
export { ForwardRef as ReactComponent };